const isClock = (s?: string) => /^\d{2}:\d{2}$/.test(s ?? '')

// formatWindowSuffix renders the inspection-window portion of a cron strategy's
// trigger label, e.g. ", window 10:00–13:00" or ", last 24h". Returns "" for
// legacy strategies whose time range is not a time-of-day window (e.g. "-86400").
export function formatWindowSuffix(start?: string, end?: string): string {
  if (!isClock(start) || !isClock(end)) return ''
  if (start === end) return ', last 24h'
  const cross = end! < start! ? ' next day' : ''
  return `, window ${start}–${end}${cross}`
}
